import { combineReducers } from 'redux';

import {
    REQUEST_USER_IDENTITY_VERIFIED,
    RECEIVE_USER_IDENTITY_VERIFIED,
    FAILURE_USER_IDENTITY_VERIFIED
} from './constants';

const verified = (state = false, action) => {
    switch (action.type) {
        case RECEIVE_USER_IDENTITY_VERIFIED:
            return action.response.payload.identityVerified;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_USER_IDENTITY_VERIFIED:
            return true;
        case FAILURE_USER_IDENTITY_VERIFIED:
        case RECEIVE_USER_IDENTITY_VERIFIED:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_USER_IDENTITY_VERIFIED:
            return action.response.message;
        case REQUEST_USER_IDENTITY_VERIFIED:
        case RECEIVE_USER_IDENTITY_VERIFIED:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    verified,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/account/identity/reducer.js